import { render } from "./AppModalEnergi.vue?vue&type=template&id=495f2ee9&scoped=true"
import script from "./AppModalEnergi.vue?vue&type=script&lang=js"
export * from "./AppModalEnergi.vue?vue&type=script&lang=js"

import "./AppModalEnergi.vue?vue&type=style&index=0&id=495f2ee9&lang=scss&scoped=true"

import exportComponent from "/Users/carolinehansen/Sites/work-manyone/koebenhavns-kommune/bygdrift/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-495f2ee9"]])

export default __exports__